var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{staticClass:"mb-8"},[_vm._v(_vm._s(_vm.$t(_vm.input.label)))]),_c('ejs-richtexteditor',{ref:"defaultRTE",attrs:{"height":400},on:{"change":_vm.change}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.initial)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }